import Select from "react-select";
import {
  getCurrentFinancialYear,
  getLastSixMonths,
  getLastThreeMonths,
  previousFinancialYear,
  previousTwoFinancialYear,
} from "../../../utils/commonFunctions";

// current year
const currentYear = getCurrentFinancialYear();
let finacialYear = currentYear;

// previous year
const previousYear = previousFinancialYear();
let previousFinacialYear = previousYear;

// previous two year
const previousTwoYear = previousTwoFinancialYear();
let previousTwoFinacialYear = previousTwoYear;

// 6 months
let lastSixMonths = getLastSixMonths();
let sixMonths = lastSixMonths;

// 3 Months
const lastThreeMonths = getLastThreeMonths();
let threeMonths = lastThreeMonths;
type DropDown = {
  label: string;
  value: string;
};

const fyDropDown: DropDown[] = [
  {
    label: "Last 3 Months",
    value: threeMonths,
  },
  {
    label: "Last 6 Months",
    value: sixMonths,
  }, 
  {
    label: "FY " + finacialYear,
    value: finacialYear,
  },
  {
    label: "FY " + previousFinacialYear,
    value: previousFinacialYear,
  },
  {
    label: " FY " + previousTwoFinacialYear,
    value: previousTwoFinacialYear,
  },


];

type AppProps = {
  changeYear?: any;
  handleDropChange: (e: DropDown) => void;
};

const InvoiceCounteHeader = ({ changeYear, handleDropChange }: AppProps) => {
  return (
    <>
      <div className=" d-flex flex-row justify-content-end" >
      <div className="mr-1" style={{ width: "150px" }}>
          <Select
            value={changeYear}
            options={fyDropDown}
            onChange={(e: any) => handleDropChange(e)}
            isSearchable={false}
          />
        </div>
      </div>
    </>
  );
};

export default InvoiceCounteHeader;
